import { createAction, props } from '@ngrx/store';

import { Offer, SecondHandMarketParams } from '../second-hand-market.interface';
import { BackendResponse } from 'src/app/core/interfaces/shared.interface';

export const setOffers = createAction(
  '[Second Hand Market Component] Set Offers',
  props<{ offers: BackendResponse<Offer>; params: SecondHandMarketParams; pageNumber: number }>()
);

export const updateOfferStatus = createAction('[Second Hand Market Component] Update Offer Status', props<{ offer: Offer }>());

// Requests

export const loadOffers = createAction(
  '[Request/Api Second Hand Market] Load Offers',
  (params: SecondHandMarketParams, pageNumber: number = 1) => ({ params, pageNumber })
);

export const changeOfferStatus = createAction(
  '[Request/Api Second Hand Market] Change Offer Status',
  props<{ id: string; status: string }>()
);
